import { Token } from 'config/types'
import { ChainIdEnum } from '../network'

const path = '/images/token'

const tokens: Record<string, Token> = {
  AVAX: {
    coinGeckoInfo: {
      id: 'avalanche-2',
    },
    logo: `${path}/avax.png`,
    displayName: 'Avalanche',
    name: 'AVAX',
    code: 'AVAX',
    network: ChainIdEnum.AVAX,
    isNative: true,
    decimals: 18,
  },
  USDT: {
    coinGeckoInfo: {
      id: 'tether',
    },
    logo: `${path}/usdt.png`,
    displayName: 'USDt',
    name: 'USDt',
    code: 'USDT',
    network: ChainIdEnum.AVAX,
    address: '0x9702230A8Ea53601f5cD2dc00fDBc13d4dF4A8c7',
    decimals: 6,
    isStable: true,
  },
}

export default tokens
